import { EQ, NEQ } from 'reporting-data/constants/operators';
export const FILTER_OPERATORS_USING_VALUE = [NEQ, EQ];